// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_ZUM","cls2":"SearchBox-cls2_1-s SearchBox-cls1_ZUM"};